<script lang="ts">
  import { fade, fly } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';
  import { CloseIcon } from '../../components/icons';
  import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
  import { onDestroy, onMount } from 'svelte';

  export let isActive = true;
  export let title = '';

  let bodyElement: HTMLElement;

  onMount(() => {
    disableBodyScroll(bodyElement);
  });

  onDestroy(() => {
    clearAllBodyScrollLocks();
  });

  const close = () => (isActive = false);
</script>

<div class="modal">
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="modal-background"
    transition:fade={{ duration: 200, easing: quintOut }}
    on:click={close}
    on:keypress
  />
  <div
    class="modal-card"
    transition:fly={{ duration: 200, y: 32, opacity: 0, easing: quintOut }}
  >
    <header class="modal-card-head">
      <p class="modal-card-title">{title}</p>
      <button class="close" on:click={close}>
        <CloseIcon />
      </button>
    </header>
    <slot name="head" />
    <section bind:this={bodyElement} class="modal-card-body">
      <slot />
    </section>
    <footer class="modal-card-foot">
      <slot name="footer" />
    </footer>
  </div>
</div>

<style>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 9999;
  }

  .modal-background {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .modal-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 580px;
    background-color: var(--fill-fill-white, #fff);
    border-radius: var(--radius-m);
    box-shadow: 0px 4px 16px 0px rgba(16, 24, 40, 0.08);
    z-index: 20;
    max-height: calc(100dvh - 80px);
  }

  .modal-card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-micro) var(--spacing-middle-lg);
    border-bottom: 1px solid var(--border-border-secondary);
  }

  .modal-card-title {
    margin: 0;
    color: var(--text-text-primary);
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.16px;
  }

  .close {
    display: flex;
    border: none;
    background: none;
    cursor: pointer;
  }

  .modal-card-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: var(--spacing-middle-lg) var(--spacing-middle-lg);
    text-align: left;
    box-sizing: border-box;
    overflow-y: auto;
  }

  @media screen and (max-width: 480px) {
    .modal-card-body {
      max-height: calc(100% - 115px);
    }

    /*check when modal has content in slot[head], this influence on the body height*/
    .modal-card:has(> :not(footer):not(header):not(section)) .modal-card-body {
      max-height: calc(100% - 185px);
    }
  }

  .modal-card-foot {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-micro) var(--spacing-middle-md);
    border-top: 1px solid var(--border-border-secondary);
  }
</style>
